import ky from 'ky';

let base_url = 'https://platform.adileproject.eu';
let token_field = 'tk';

let endpoint = ky.create({
  prefixUrl: base_url + '/',
});

export class api {
  static base_url = base_url;
  static auth_token = undefined;

  static is_loggedin() {
    return this.auth_token == undefined ? false : true;
  }

  static async refresh_token() {
    let refresh_token = localStorage.getItem(token_field);
    if ( refresh_token !== null ) {
      let body = {
        "refresh_token": refresh_token
      };
      try {
        let resp = await endpoint.post('auth/refresh', {json: body}).json();
        this.auth_token = resp.data.access_token;
        localStorage.setItem(token_field, resp.data.refresh_token);
      } catch {
        this.auth_token = undefined;
        localStorage.removeItem(token_field);
      }
    }
  }

  static async login(email, password) {
    if ( !this.is_loggedin() ) {
      let body = {
        "email": email,
        "password": password
      };
      let resp = await endpoint.post('auth/login', {json: body}).json();
      this.auth_token = resp.data.access_token;
      localStorage.setItem(token_field, resp.data.refresh_token);
    } else {
      return {data: []};
    }
  }

  static async logout() {
    if ( this.is_loggedin() ) {
      let refresh_token = localStorage.getItem(token_field);
      let body = {
        "refresh_token": refresh_token
      };
      await endpoint.post('auth/logout', {json: body}).json();
      this.auth_token = undefined;
      localStorage.removeItem(token_field);
    }
      return;
  }

  static async get_user_self() {
    if ( this.is_loggedin() ) {
      let query = "?fields=*,affiliation.*";
      let auth = "&access_token=" + this.auth_token;
      return await endpoint.get('users' + query + auth).json();
    } else {
      return {data: []};
    }
  }

  static async get_courses() {
    if ( this.is_loggedin() ) {
      let query = "?fields=*";
      let auth = "&access_token=" + this.auth_token;
      return await endpoint.get('items/courses' + query + auth).json();
    } else {
      return {data: []};
    }
  }

  static async get_course(course_id) {
    if ( this.is_loggedin() ) {
      let query = "?filter[id][_eq]=" + course_id;
      query = query + "&fields=*,modules.*.*";
      let auth = "&access_token=" + this.auth_token;
      return await endpoint.get('items/courses' + query + auth).json();
    } else {
      return {data: []};
    }
  }

  static async submit_results(module_id, json_content) {
    if ( this.is_loggedin() ) {
      let auth = "?access_token=" + this.auth_token;
      let body = {
        module: module_id,
        answers: json_content
      }
      return await endpoint.post('items/results' + auth, {json: body});
    } else {
      return {data: []};
    }
  }
}